var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 4a2 2 0 012 2v12a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h16zm0 1.5H4a.5.5 0 00-.492.41L3.5 6v12a.5.5 0 00.41.492L4 18.5h16a.5.5 0 00.492-.41L20.5 18V6a.5.5 0 00-.41-.492L20 5.5zM9.5 9.809a.5.5 0 01.646-.478l.078.03 4.382 2.192a.5.5 0 01.078.846l-.078.048-4.382 2.191a.5.5 0 01-.717-.364l-.007-.083V9.809z",
    fill: "currentColor"
  })));
}

export default SvgVideo;